import {
  autoSignIn,
  confirmResetPassword,
  confirmSignIn,
  confirmSignUp,
  deleteUser,
  fetchAuthSession,
  getCurrentUser,
  resendSignUpCode,
  resetPassword,
  signIn,
  signInWithRedirect,
  signOut,
  signUp,
} from 'aws-amplify/auth'

import {
  TConfirmResetPasswordInput,
  TConfirmSignInInput,
  TConfirmSignUpInput,
  TEmailInput,
  TSignInput,
} from '~/features/auth/models'
import { TCustomOAuthState } from '~/models/auth'
import EEnvironmentVariables from '~/models/config'

class AuthService {
  public static async signIn({ email: username, password }: TSignInput) {
    return signIn({ username, password })
  }

  public static async signInOidc() {
    return signInWithRedirect({
      provider: {
        custom: import.meta.env[EEnvironmentVariables.VITE_OIDC_NAME],
      },
    })
  }

  public static async signOut(): Promise<void> {
    return signOut({ global: true })
  }

  public static async signUp({ email, password }: TSignInput) {
    return signUp({
      username: email,
      password,
      options: {
        userAttributes: {
          email,
        },
        autoSignIn: true,
      },
    })
  }

  public static async confirmSignUp({ email, code }: TConfirmSignUpInput) {
    return confirmSignUp({
      username: email,
      confirmationCode: code,
    })
  }

  public static async resendSignUpCode({ email }: TEmailInput) {
    return resendSignUpCode({ username: email })
  }

  public static async confirmSignIn({ newPassword }: TConfirmSignInInput) {
    return confirmSignIn({ challengeResponse: newPassword })
  }

  public static async autoSignIn() {
    return autoSignIn()
  }

  public static async resetPassword({ email }: TEmailInput) {
    return resetPassword({ username: email })
  }

  public static async confirmResetPassword({
    email,
    password,
    code,
  }: TConfirmResetPasswordInput) {
    return confirmResetPassword({
      username: email,
      newPassword: password,
      confirmationCode: code,
    })
  }

  public static async signInWithGoogle(customState: TCustomOAuthState) {
    return signInWithRedirect({
      provider: 'Google',
      customState: JSON.stringify(customState),
    })
  }

  public static async deleteUser() {
    return deleteUser()
  }

  public static async fetchAuthSession() {
    return fetchAuthSession({ forceRefresh: true })
  }

  public static async getCurrentUser() {
    return getCurrentUser()
  }
}

export default AuthService
